import { useState, useEffect } from "react";
import { useSelector } from "react-redux";

import RadioInput from "@stadium/ui/src/components/form/RadioInput";
import Label from "@stadium/ui/src/components/form/Label";

import { useJuneSoEventTracking } from "@stadium/services/june-analytics/hooks/use-june-so-event-tracking";
import useRouter from "@stadium/hooks/lib/use-custom-route";

import { useSendItemsContext } from "@contexts/send-items-context";

import { useHandleSendToManyToggle } from "@hooks/cart/use-handle-send-to-many-toggle";

import { getCartProductZoneList } from "@selectors/cart";

import {
  DEFAULT_SERVICES,
  YOUR_BAG,
  SEND_TO_MYSELF as SEND_TO_MYSELF_JUNE_SO,
  SEND_TO_OTHER,
} from "@constants/june-so";

import { SEND_ITEMS_SELECTION_OPTINS, SEND_TO_MYSELF } from "@constants/navigation";

import styles from "./main.module.scss";
import { useCartListingContext } from "@contexts/cart-listing-context";
import { CART_PAGE_PATHNAME } from "@constants/routes";
import { OLD_CART_PAGE_PATHNAME } from "@constants/old-routes";

const SendItemsSelectionCart = () => {
  const router = useRouter();
  const { pathname: routerPathName } = router;
  const cartProductZoneList = useSelector(getCartProductZoneList);

  const { sendItemsSelection, setSendItemsSelection, openCountrySelectorModal } =
    useSendItemsContext();

  const { trackEvent } = useJuneSoEventTracking({ services: DEFAULT_SERVICES });

  const { updateOrderStatus } = useHandleSendToManyToggle();

  const { getSwagVariantsSelectionProducts, openSwagVariantSelectorModal } =
    useCartListingContext();

  const [sendItemsRadio, setSendItemsRadio] = useState(sendItemsSelection);

  const updateSelectionRadio = (value) => {
    setSendItemsRadio(value);
    setSendItemsSelection(value);
  };

  const sendItemsOnRadioChange = ({ value }) => {
    if (value === SEND_TO_MYSELF && cartProductZoneList.length > 1)
      return openCountrySelectorModal();
    updateOrderStatus(value);
    updateSelectionRadio(value);
    trackEvent({
      componentName: YOUR_BAG,
      target: value === SEND_TO_MYSELF ? SEND_TO_MYSELF_JUNE_SO : SEND_TO_OTHER,
    });
  };

  useEffect(() => {
    if (sendItemsRadio !== sendItemsSelection) setSendItemsRadio(sendItemsSelection);
  }, [sendItemsSelection]);

  useEffect(() => {
    if (sendItemsRadio === SEND_TO_MYSELF) {
      if (![CART_PAGE_PATHNAME, OLD_CART_PAGE_PATHNAME].includes(routerPathName)) return;
      const productList = getSwagVariantsSelectionProducts();
      if (productList.length > 0) return openSwagVariantSelectorModal();
    }
  }, [sendItemsRadio, getSwagVariantsSelectionProducts]);

  const radioGroupProps = {
    name: "send-items-selection",
    onChange: sendItemsOnRadioChange,
  };

  return (
    <div className={styles.radioBlock}>
      {Object.values(SEND_ITEMS_SELECTION_OPTINS).map(({ key, value, label }) => (
        <RadioInput
          key={key}
          id={key}
          value={value}
          checked={sendItemsRadio === key}
          label={
            <Label htmlFor={key} iconType="radioOutline" styles={styles}>
              {label}
            </Label>
          }
          {...radioGroupProps}
        />
      ))}
    </div>
  );
};
export default SendItemsSelectionCart;
